<template>
  <div class="w-full text-center">
    TextMessage
  </div>
</template>
